import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Box, Button, Card, CardContent, CardHeader, Divider, LinearProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { dashboardBnmRates, formatBnmDate } from '../../../utils/bnmRates';
import { euFlag, roFlag, ruFlag, uaFlag, usFlag } from '../../Data/imageURL';

const flags = { EUR: euFlag, USD: usFlag, RUB: ruFlag, RON: roFlag, UAH: uaFlag };

export default function BnmRatesCard({ exchangeRates, isFetching = false, isError = false, onRetry }) {
  const { t } = useTranslation();
  const rows = dashboardBnmRates(exchangeRates?.Valute);
  const date = formatBnmDate(exchangeRates?.Date);
  const retry = onRetry ? <Button color="inherit" size="small" onClick={onRetry}>{t('dashboard.exchange_rates_retry')}</Button> : undefined;
  return (
    <Card sx={{ height: 520, maxWidth: 'auto' }}>
      <CardHeader
        title={t('dashboard.exchange_rates_nbm')}
        subheader={date ? `${t('dashboard.exchange_rate_updated_for')} ${date}` : undefined}
        subheaderTypographyProps={{ fontWeight: 500 }}
        sx={{ backgroundColor: '#f1f1f1', minHeight: 85 }}
      />
      <Divider />
      {isFetching && <LinearProgress />}
      <CardContent>
        {rows.length === 0 ? (
          isFetching ? (
            <Box role="status">{t('dashboard.exchange_rates_loading')}</Box>
          ) : (
            <Alert severity="warning" action={retry}>{t('dashboard.exchange_rates_unavailable')}</Alert>
          )
        ) : (
          <>
            {(exchangeRates?.stale || isError) && (
              <Alert severity="warning" action={retry} sx={{ mb: 1 }}>{t('dashboard.exchange_rates_stale')}</Alert>
            )}
            <TableContainer>
              <Table size="small" aria-label="exchange rates">
                <TableHead><TableRow>
                  <TableCell>{t('inv.currency')}</TableCell>
                  <TableCell align="right">{t('dashboard.exchange_rate_nbm')}</TableCell>
                </TableRow></TableHead>
                <TableBody>{rows.map((row) => (
                  <TableRow key={row.CharCode} sx={{ '&:last-child td': { border: 0 } }}>
                    <TableCell><Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <img src={flags[row.CharCode]} alt={row.CharCode} style={{ width: 30, height: 'auto' }} />
                      {row.CharCode}
                    </Box></TableCell>
                    <TableCell align="right" sx={{ fontWeight: 500 }}>{row.Value}</TableCell>
                  </TableRow>
                ))}</TableBody>
              </Table>
            </TableContainer>
          </>
        )}
      </CardContent>
    </Card>
  );
}
